
import "./UiText.css";

import { computed, defineComponent, PropType } from "vue";

import { usePlatform } from "@/hooks/usePlatform";
import { getClassName } from "@/lib/getClassName";

type TextWeight = "semibold" | "medium" | "regular";

export default defineComponent({
  inheritAttrs: false,

  props: {
    weight: { type: String as PropType<TextWeight>, default: "regular" },
    tag: { type: String, default: "span" },
  },

  setup(props) {
    const platform = usePlatform();

    const rootClasses = computed(() => [
      getClassName("UiText", platform),
      `UiText--w-${props.weight}`,
      {},
    ]);

    return {
      props,
      rootClasses,
    };
  },
});
